import React from 'react';

import {ImagesCarousel} from 'app/general/widgets/ImagesCarousel';

import type {ProcessorType} from '../node-processors-types';
import type {AttachedImage} from 'sweet-types';

export const CarouselEmbedProcessor: ProcessorType = {
  tag: 'carousel',
  condition: () => true,
  processor: (node, index, transform, opts) => {
    const images: Array<AttachedImage> = [];

    node.children.forEach((node) => {
      if ('attribs' in node) {
        const src = node.attribs['src'];
        if (src != null && src != '') {
          images.push({
            embed_html: '',
            embed_thumb: '',
            image_ref: src
              .replace(opts.mediaURL, '')
              .replace(opts.mediaURLRead, ''),
          });
        }
      }
    });

    return [
      null,
      <ImagesCarousel
        key={images.length}
        images={images}
        className="step-images"
      />,
    ];
  },
};
